<template>
  <div class="btn-group flex-nowrap">
    <button :class="['btn']" :disabled="page === 1" @click="handleClick({ type: 'prev' })">
      <hero-icon name="chevron-left" />
    </button>
    <template v-for="item in items" :key="item.value">
      <button
        v-if="item.value"
        :class="['btn', { 'btn-active': item.value === page }]"
        @click="handleClick(item)">
        {{ item.value }}
      </button>
      <button :class="['btn group']" v-else @click="handleClick(item)">
        <hero-icon class="group-hover:hidden" name="dots-horizontal" />
        <hero-icon class="hidden group-hover:block" :name="`chevron-double-${item.type}`" />
      </button>
    </template>
    <button :class="['btn']" :disabled="page >= pageCount" @click="handleClick({ type: 'next' })">
      <hero-icon name="chevron-right" />
    </button>
  </div>
</template>
<script>
export default {
  props: {
    page: { type: Number, default: 1 },
    limit: { type: Number, default: 20 },
    total: { type: Number, default: 0 }
  },
  computed: {
    pageCount () {
      const isAdd = (this.total % this.limit !== 0)
      const value = Math.trunc(this.total / this.limit) + (isAdd ? 1 : 0)
      return value
    },
    items () {
      const items = []
      if (this.pageCount > 9) {
        for (const val of Array(9).keys()) {
          if (this.page < 5) {
            if (val === 7) {
              items.push({ type: 'right' })
            } else if (val === 8) {
              items.push({ value: this.pageCount })
            } else {
              items.push({ value: val + 1 })
            }
          } else if (this.page > (this.pageCount - 5)) {
            if (val === 1) {
              items.push({ type: 'left' })
            } else if (val === 0) {
              items.push({ value: 1 })
            } else {
              items.push({ value: this.pageCount - (8 - val) })
            }
          } else {
            if (val === 1) {
              items.push({ type: 'left' })
            } else if (val === 7) {
              items.push({ type: 'right' })
            } else if (val === 0) {
              items.push({ value: 1 })
            } else if (val === 8) {
              items.push({ value: this.pageCount })
            } else {
              items.push({ value: this.page - (4 - val) })
            }
          }
        }
      } else {
        for (const val of Array(this.pageCount).keys()) {
          items.push({ value: val + 1 })
        }
      }
      return items
    }
  },
  methods: {
    handleClick (item) {
      let page = this.page
      if (item.type === 'next') {
        page++
      } else if (item.type === 'prev') {
        page--
      } else if (item.type === 'right') {
        page = Math.min(this.pageCount, page + 5)
      } else if (item.type === 'left') {
        page = Math.max(1, page - 5)
      } else {
        page = item.value
      }
      if (this.page !== page) {
        this.$emit('change', page)
      }
    }
  }
}
</script>
